import styles from './companyStatsTable.module.scss';
function CompanyStatsHeader() {
  return (
    <thead>
      <tr>
        <th className={styles.userColumn}>Utilisateur</th>
        <th>Connexions</th>
        <th>Annonces étudiées</th>
        <th>Démarches entreprises</th>
        <th>Recherches actives</th>
        <th>Etudes comparatives</th>
      </tr>
    </thead>
  );
}

export default CompanyStatsHeader;
